import { type UseQueryResult, useQuery } from 'react-query';
import {
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto,
} from '../../services/wealthlane-award-services';
import { useSelector } from 'react-redux';
import { selectTenantId } from '../../pages/configuration/participantSignupSlice';
import { ParticipantTradePreClearanceService } from '../../services/wealthlane-award-services/services/ParticipantTradePreClearanceService';
import { isEmpty } from 'lodash';

const useGetParticipantTradePreClearances = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto | undefined,
  unknown
> => {
  const tenantId = useSelector(selectTenantId);
  const participantTradePreClearances = useQuery(
    ['getParticipantTradePreClearances', isOnBoarded],
    async () => {
      if (tenantId && isOnBoarded === true) {
        return await handleRequest(
          ParticipantTradePreClearanceService.getApiAwardApiAppParticipantTradePreClearanceParticipantTradePreClearance()
        );
      }
    }
  );

  return participantTradePreClearances;
};

export default useGetParticipantTradePreClearances;
